<template>
  <div class="slide-wrapper">
    <!-- 2md slide -->
    <div class="slide slide-main">
      <slot name="main" />
    </div>

    <!-- 1st slide -->
    <div class="slide slide-secondary" :style="secondarySlideStyle">
      <slot name="secondary" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue';

const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
  direction: {
    type: String as PropType<'left' | 'right'>,
    default: 'right', // direction of slide-animation
  },
});

const secondarySlideStyle = computed(() => ({
  transform: `translateX(${props.isVisible ? '0' : '100%'})`,
}));
</script>

<style scoped lang="css">
@reference "tailwindcss";
@reference "tailwindcss/utilities";

:root {
  --slide-animation-duration: 0.3s;
}

.slide-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform var(--slide-animation-duration) ease-out;
  overflow: auto;
}

.slide-main {
  position: relative; /* static in background */
  z-index: 1;
  background-color: var(--surface-ground);
}

.slide-secondary {
  z-index: 2;
  background-color: var(--surface-ground);
}
</style>
